import React, { useEffect, useState, useContext } from 'react';

import { ReactComponent as CurrentPriceWhiteIcon } from '../../assets/icons/current-price-sae-white.svg';
import { ReactComponent as ActiveGraph } from '../../assets/icons/dynamic-pricing/active-graph.svg';
import { ReactComponent as ActiveReports } from '../../assets/icons/dynamic-pricing/active-reports.svg';
import { ReactComponent as CloseStatus } from '../../assets/icons/dynamic-pricing/close-status.svg';
import { ReactComponent as Graph } from '../../assets/icons/dynamic-pricing/graph.svg';
import { ReactComponent as Status } from '../../assets/icons/dynamic-pricing/open-status.svg';
import { ReactComponent as PendingIcon } from '../../assets/icons/dynamic-pricing/pending-icon.svg';
import { ReactComponent as Reports } from '../../assets/icons/dynamic-pricing/reports.svg';
// import { ReactComponent as Settings } from '../../assets/icons/dynamic-pricing/settings.svg';
import { ReactComponent as DefaultStationImage } from '../../assets/icons/dynamic-pricing/station-icon-view.svg';
import { ReactComponent as Station } from '../../assets/icons/dynamic-pricing/station.svg';
import { ReactComponent as ActiveGraphDark } from '../../assets/icons/iconsDark/dynamic-pricing-graph-active-dark.svg';
import { ReactComponent as GraphDark } from '../../assets/icons/iconsDark/dynamic-pricing-graph-dark.svg';
import { ReactComponent as ActiveReportsDark } from '../../assets/icons/iconsDark/dynamic-pricing-report-active-dark.svg';
import { ReactComponent as ReportsDark } from '../../assets/icons/iconsDark/dynamic-pricing-report-dark.svg';
import { ReactComponent as StationDark } from '../../assets/icons/iconsDark/dynamic-pricing-station-dark.svg';
import { ReactComponent as UpdatePriceDark } from '../../assets/icons/iconsDark/dynamic-pricing-update-price-dark.svg';
// import { ReactComponent as ExportDark } from '../../assets/icons/iconsDark/export-icon-dark.svg';
import { ReactComponent as Clock } from '../../assets/icons/timer-icon.svg';
import { ReactComponent as UpdatePrice } from '../../assets/icons/update-price.svg';
import { brandIcons ,currentBranding} from '../../config/branding';
import {branding} from "../../config/enum";
import ThemeContext from '../../contexts/theme-context/ThemeContext';
import {
  MultiMediaData,
  StationDetailsDynamicPrizing,
  UpdateDynamicTimingProperties,
} from '../../interface/dynamic-pricing.interface';
import { ReportsList } from '../../interface/reports.interface';
import { useAppDispatch, useAppSelector } from '../../redux/hooks';
import { fetchAllStationsList } from '../../redux/slice/ApprovedStationManagementSlice';
import { setNotificationDetails } from '../../redux/slice/NotificationSlice';
import MyButton from '../../shared-components/button/Button';
import CustomTableStaticFilter from '../../shared-components/custom-table-static-filter/CustomTableStaticFilter';
import CustomToggleButton from '../../shared-components/custom-toggle-button/CustomToggleButton';
import ModalBox from '../../shared-components/modal-box/ModalBox';
import InputBox from '../../shared-components/pricing-input/PricingInput';
import RevenueExpenseChart from '../../shared-components/revenue-expense-chart/RevenueExpenseChart';
import SelectFiled from '../../shared-components/select-field/SelectField';
import SuccessNotification from '../../shared-components/success-notification/SuccessNotificaion';
import ConvertUTCtoHHMM from '../../shared-functions/ConvertUTCtoHHMM';
import { isWithinOperatingHours } from '../../shared-functions/DataTime';
import { FormatUtcString } from '../../shared-functions/FormatUtcString';
import dynamicPrizeApi from '../../utils/api/dynamic-prize';

import BaseRateList from './components/BaseRate';
import OffPeakRateList from './components/OffPeakRate';
import PeakRateList from './components/PeakRate';
import TimeUpdate from './components/TimeUpdate';

interface ModalBoxDetail {
  title: string | null;
  header: boolean;
  content: JSX.Element | null;
  notificationModal: boolean;
  notification: boolean;
}

/**
 * Function to choose a random image for list of uploaded medias
 * @param medias
 */
const selectRandomStationImage = (medias: MultiMediaData[]) => {
  if (!medias.length) {
    return null;
  }

  // Filter uploaded images
  const uploadedImages = medias.filter((media) => media?.fileType?.includes('image'));

  // If there are no uploaded images, return null
  if (!uploadedImages.length) {
    return null;
  }

  // Choose a random image
  const randomIndex = Math.floor(Math.random() * uploadedImages.length);
  return uploadedImages[randomIndex]?.signedUrl || null;
};

/**
 * DynamicPricing component for managing pricing strategies dynamically.
 *
 * This component allows users to set pricing rules based on various conditions.
 * It provides functionality to submit and validate pricing changes.
 * @returns {JSX.Element} The rendered DynamicPricing component.
 */
function DynamicPricing() {
  const dispatch = useAppDispatch();
  const { allStations } = useAppSelector((state) => state.approvedStation);
  const { theme } = useContext(ThemeContext);
  const [modalBoxStatus, setModalBoxStatus] = useState<'open' | 'close'>('close');
  const [tablePage, setTablePage] = useState<string>('base');
  const [loader, setLoader] = useState<boolean>(false);

  const [stationDetails, setStationDetails] = useState<StationDetailsDynamicPrizing>({
    pricing: {
      base: '',
      peak: '',
      offpeak: '',
    },
    pendingPricing: {
      base: '',
      peak: '',
      offpeak: '',
    },
    chargingStation: {
      _id: '',
      name: '',
      electricityContractType: '',
      opensAt: '',
      closesAt: '',
      address: '',
      latitude: '',
      longitude: '',
      isAvailable: false,
      submission: {
        status: '',
        reason: '',
      },
      amenities: [],
      accountCustomId: '',
      medias: [],
      landOwnerShipDocument: [],
      ebReport: [],
      createdAt: '',
    },
  });

  const [modalBoxDetail, setModalBoxDetail] = useState<ModalBoxDetail>({
    title: '',
    content: null,
    header: false,
    notificationModal: true,
    notification: false,
  });

  const [reports, setReports] = useState<ReportsList>({
    status: 0,
    newSelectedValues: '',
    CurrentPricing: '',
    UpdatePricing: '',
    opensAt: '',
    closesAt: '',
    fromDate: '',
    toDate: '',
    pricingList: '',
    pricing: '',
    page: 'base',
  });

  const [tableToggleLabel, setTableToggleLabel] = useState([
    {
      label: 'Base Rate',
      key: 'base',
      isActive: true,
    },
    {
      label: 'Peak Rate',
      key: 'peak',
      isActive: false,
    },
    {
      label: 'off Peak Rate',
      key: 'offpeak',
      isActive: false,
    },
  ]);

  const [randomImageURL, setRandomImageURL] = useState<string | null>(null);

  /**
   * value
   * @param value
   * @param label
   */
  const handleOnToggle = (value: number) => {
    let currentPrice = '';
    let updatedPrice = '';
    switch (value) {
      case 0:
        currentPrice = stationDetails.pricing.base;
        updatedPrice = stationDetails?.pendingPricing?.base;
        break;
      case 1:
        currentPrice = stationDetails.pricing.peak;
        updatedPrice = stationDetails?.pendingPricing?.peak;
        break;
      case 2:
        currentPrice = stationDetails.pricing.offpeak;
        updatedPrice = stationDetails?.pendingPricing?.offpeak;
        break;

      default:
        break;
    }
    setReports((previous) => ({
      ...previous,
      page: tableToggleLabel[value].key,
      CurrentPricing: currentPrice,
      UpdatePricing: updatedPrice,
    }));
  };

  /**
   * Get the station details function
   * @param stationId
   */
  const getStationDetails = (stationId: string) => {
    dynamicPrizeApi
      .fetchStationDetails(stationId)
      .then((response) => {
        setStationDetails(response.data);
        setReports((previous) => ({
          ...previous,
          CurrentPricing: response.data.pricing[reports.page],
          UpdatePricing: response.data.pendingPricing[reports.page] || '',
        }));
      })
      .catch((error) => {
        dispatch(
          setNotificationDetails({
            type: 'error',
            notificationDetails: {
              statusCode: error?.response?.data?.code || 200,
              message: error?.response?.data?.message || 'Something went wrong!',
            },
          }),
        );
      });
  };

  /**
   * rule
   * @param key
   */
  const handleToggleButton = (clickedKey: string) => {
    setTablePage(clickedKey);
    const clickedItem = tableToggleLabel.find((item) => item.key === clickedKey);
    setTableToggleLabel((previousValue) => {
      return previousValue.map((item) => {
        if (item?.key === clickedKey) {
          return {
            ...item,
            isActive: true, // Toggle the isActive property to true for the clicked item
          };
        }
        if (item?.key) {
          return {
            ...item,
            isActive: false, // Toggle the isActive property to true for the clicked item
          };
        }
        return item; // Return the item as is if it doesn't match the clicked key
      });
    });
    setReports((previous) => ({
      ...previous,
      pricingList: clickedItem?.label,
    }));
  };

  /**
   * Handles the submission of a form or an action.
   *
   * This function is triggered when the user submits the form, 
   * and it processes the input values as necessary.
   
   */
  const submitPrizing = () => {
    setLoader(true);
    dynamicPrizeApi
      .updateDynamicPrizing({
        chargingStation: reports.newSelectedValues,
        pricingType: reports.page,
        price: reports.UpdatePricing,
      })
      .then(() => {
        setLoader(false);
        setModalBoxStatus('open');
        setModalBoxDetail({
          title: '',
          header: false,
          notification: true,
          content: (
            <SuccessNotification
              title="Pricing Updated Successfully..."
              description=""
              notificationCloseTimer={3000}
              onNotificationClose={() => {
                getStationDetails(reports.newSelectedValues);
                setModalBoxStatus('close');
              }}
            />
          ),
          notificationModal: false,
        });
        // setReports((previous) => ({
        //   ...previous,
        //   UpdatePricing: '',
        // }));
      })
      .catch((error) => {
        setLoader(false);
        dispatch(
          setNotificationDetails({
            type: 'error',
            notificationDetails: {
              statusCode: error?.response?.data?.code || 200,
              message: error?.response?.data?.message || 'Something went wrong!',
            },
          }),
        );
      });
  };

  /**
   * Submit the handle update timing function
   * @param data
   */
  const handleUpdateTiming = (
    data: UpdateDynamicTimingProperties,
    stopLoader: (value: boolean) => void,
  ) => {
    dynamicPrizeApi
      .updateDynamicTiming({
        ...data,
        chargingStation: reports.newSelectedValues,
      })
      .then(() => {
        stopLoader(false);
        setModalBoxStatus('open');
        setModalBoxDetail({
          title: 'Update Timing',
          header: false,
          notification: true,
          content: (
            <SuccessNotification
              title="Timing Updated Successfully..."
              description=""
              notificationCloseTimer={3000}
              onNotificationClose={() => {
                setModalBoxStatus('close');
              }}
            />
          ),
          notificationModal: false,
        });
      })
      .catch((error) => {
        stopLoader(false);
        dispatch(
          setNotificationDetails({
            type: 'error',
            notificationDetails: {
              statusCode: error?.response?.data?.code || 200,
              message: error?.response?.data?.message || 'Something went wrong!',
            },
          }),
        );
      });
  };

  /**
   * Update time for prices
   */
  const handleUpdateTime = () => {
    dynamicPrizeApi
      .oldTimingChanges(reports.newSelectedValues)
      .then((response) => {
        setModalBoxDetail({
          title: 'Update Timing',
          header: true,
          notification: true,
          content: (
            <TimeUpdate
              handleCancel={() => setModalBoxStatus('close')}
              submitFunction={handleUpdateTiming}
              oldData={response.data}
            />
          ),
          notificationModal: false,
        });
        setModalBoxStatus('open');
      })
      .catch((error) => {
        dispatch(
          setNotificationDetails({
            type: 'error',
            notificationDetails: {
              statusCode: error?.response?.data?.code || 200,
              message: error?.response?.data?.message || 'Something went wrong!',
            },
          }),
        );
      });
  };

  /**
   * Handles the toggle of a report status.
   *
   * This function updates the status of reports based on the provided value.
   * @param {number|string} value - The new status value for the reports.
   */
  const onToggle = (value: number | string) => {
    setReports((previous) => ({
      ...previous,
      status: value,
    }));
  };

  /**
   * Handles the change in selected values.
   *
   * This function updates the reports state with the newly selected values.
   * @param {string[]} newSelectedValues - An array of selected values to update the reports state.
   */
  const handleSelectionChange = (name: string, newSelectedValues: string) => {
    setReports((previous) => ({
      ...previous,
      [name]: newSelectedValues,
    }));
    getStationDetails(newSelectedValues);
  };

  const amenitiesDetails = [
    {
      key: 'Gas Station',
      svgIconActive: <brandIcons.GasStationActive />,
    },
    {
      key: 'Free Wifi',
      svgIconActive: <brandIcons.WifiActive />,
    },
    {
      key: 'Restroom',
      svgIconActive: <brandIcons.RestroomActive />,
    },
    {
      key: 'Lounge',
      svgIconActive: <brandIcons.LoungeActive />,
    },
    {
      key: 'Cafe',
      svgIconActive: <brandIcons.CaffeeActive />,
    },
    {
      key: 'Shopping',
      svgIconActive: <brandIcons.ShoppingActive />,
    },
    {
      key: 'Restaurant',
      svgIconActive: <brandIcons.RestaurantActive />,
    },
    {
      key: 'Relaxing Area',
      svgIconActive: <brandIcons.RelaxingActive />,
    },
    {
      key: 'Locker',
      svgIconActive: <brandIcons.LockerActive />,
    },
    {
      key: 'Work Shop',
      svgIconActive: <brandIcons.WorkshopActive />,
    },
    {
      key: 'Car Wash',
      svgIconActive: <brandIcons.CarwashActive />,
    },
  ];

  /**
   * getIcons
   */
  const getIcons = () => ({
    defaultIcons: [
      theme === 'light' ? <Graph /> : <GraphDark />,
      theme === 'light' ? <Reports /> : <ReportsDark />,
    ],
    activeIcons: [
      theme === 'light' ? <ActiveGraph /> : <ActiveGraphDark />,
      theme === 'light' ? <ActiveReports /> : <ActiveReportsDark />,
    ],
  });
  const { defaultIcons, activeIcons } = getIcons();

  /**
   * Updates a specific value in the reports state.
   *
   * This function sets the report's state based on the provided name and value.
   * @param {string} name - The name of the property to update in the reports state.
   * @param {string|number} value - The new value to set for the specified property.
   */
  const onChangeValue = (name: string, value: string | number) => {
    setReports((previous) => ({
      ...previous,
      [name]: value,
    }));
  };

  useEffect(() => {
    if (allStations.length && !stationDetails.chargingStation._id) {
      getStationDetails(allStations?.[0]?.value);
      setReports((previous) => ({
        ...previous,
        newSelectedValues: allStations?.[0]?.value,
      }));
    }
  }, [allStations]);

  useEffect(() => {
    if (stationDetails.chargingStation.medias.length) {
      const imageUrl = selectRandomStationImage(stationDetails.chargingStation.medias);
      setRandomImageURL(imageUrl);
    }
  }, [stationDetails]);

  useEffect(() => {
    if (allStations.length === 0) {
      dispatch(fetchAllStationsList());
    }
  }, []);

  return (
    <div className="pricing-main-container">
      <ModalBox
        open={modalBoxStatus === 'open'}
        title={modalBoxDetail.title}
        content={modalBoxDetail.content}
        closeModal={() => setModalBoxStatus('close')}
        modalBoxAnimation="modalAnimateToLeft"
        header={modalBoxDetail.notificationModal}
        notification={modalBoxDetail.notification}
      />
      <div className="pricing-title">Dynamic Pricing</div>
      <div className="pricing-sub-container">
        <div className="pricing-header">
          <div className="multi-select-container">
            <SelectFiled
              name="newSelectedValues"
              placeholder="Select Station"
              options={allStations}
              svgIcon={theme === 'light' ? <Station /> : <StationDark />}
              selectedValue={reports.newSelectedValues}
              onChangeValue={handleSelectionChange}
            />
          </div>
        </div>
        <div className="pricing-content">
          <div className="station-details">
            <div className="station-title">Station Details</div>
            <div className="station-address">
              {(() => {
                let randomStationImage = (
                  <div>
                    <DefaultStationImage />
                  </div>
                );
                if (randomImageURL) {
                  randomStationImage = (
                    <img src={randomImageURL} alt="" className="station-image" />
                  );
                }
                return randomStationImage;
              })()}
              {stationDetails.chargingStation.name && (
                <div className="station-address-details">
                  <p>{stationDetails.chargingStation.name}</p>
                  <div className="address-details">{stationDetails.chargingStation.address}</div>
                  <div className="station-status">
                    {/* To-do -> Need to work on compare UTC time with system current time */}
                    {isWithinOperatingHours(
                      stationDetails.chargingStation.opensAt,
                      stationDetails.chargingStation.closesAt,
                    ) ? (
                      <div className="opening-status">
                        <p>
                          <Status />
                        </p>
                        <p>Open</p>
                      </div>
                    ) : (
                      <div className="opening-status">
                        <p>
                          <CloseStatus />
                        </p>
                        <p>Closed</p>
                      </div>
                    )}
                    <div className="timing">
                      <p>
                        <Clock />
                      </p>
                      <p>
                        {FormatUtcString(ConvertUTCtoHHMM(stationDetails.chargingStation.opensAt))}{' '}
                        -{' '}
                        {FormatUtcString(ConvertUTCtoHHMM(stationDetails.chargingStation.closesAt))}
                      </p>
                    </div>
                  </div>
                </div>
              )}
            </div>
            {stationDetails.chargingStation.amenities.length > 0 && (
              <div className="station-feature">
                {amenitiesDetails
                  .filter((value) => stationDetails.chargingStation.amenities.includes(value.key))
                  .map((item) => (
                    <div className="amenities-icon">{item.svgIconActive}</div>
                  ))}
              </div>
            )}
          </div>
          <div className="pricing-details">
            <div className="pricing-title">Enter Pricing</div>
            <div className="pricing-main-content">
              <div className="pricing-filter">
                <CustomToggleButton
                  labels={['Base Rate', 'Peak Rate', 'Off Peak rate']}
                  onToggle={handleOnToggle}
                  defaultActiveIndex={0}
                />
              </div>
              <div className="current-price">
                <InputBox
                  label="per (KWh)"
                  type="text"
                  value={reports?.CurrentPricing || ''}
                  onChange={onChangeValue}
                  placeholder="Current Pricing"
                  name="CurrentPricing"
                  readonly
                  icon={
                    currentBranding === branding.ENERGIC && theme === 'dark' ? (
                      <CurrentPriceWhiteIcon />
                    ) : (
                      <brandIcons.CurrentPriceIcon />
                    )
                  }
                  className="custom-input"
                />
              </div>
              <div className="update-price">
                <InputBox
                  label="per (KWh)"
                  type="number"
                  value={reports?.UpdatePricing || ''}
                  onChange={onChangeValue}
                  placeholder="Update Pricing"
                  name="UpdatePricing"
                  icon={theme === 'light' ? <UpdatePrice /> : <UpdatePriceDark />}
                  className="custom-input"
                />
              </div>
              <div className="Pricing-buttons">
                {Object.keys(stationDetails.pendingPricing)?.length > 0 ? (
                  <div className="pricing-pending-state">
                    <span>
                      <PendingIcon />
                    </span>
                    <span>Pending</span>
                  </div>
                ) : (
                  <div />
                )}
                <div className="pricing-buttons">
                  <MyButton
                    label="Update time"
                    buttonType="submit"
                    svgIcon={<Clock />}
                    disableHoverEffect
                    onClickFunc={handleUpdateTime}
                  />
                  <MyButton
                    label="Save"
                    buttonType="submit"
                    onClickFunc={submitPrizing}
                    disableButton={reports.UpdatePricing === '' || loader}
                    loading={loader}
                    disableClass={reports.UpdatePricing === '' ? 'disabled' : ''}
                    disableHoverEffect
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="pricing-reports">
          <div className="pricing-reports-header">
            <CustomToggleButton
              labels={['Graph', 'Report List']}
              icons={defaultIcons}
              activeIcons={activeIcons}
              onToggle={onToggle}
              defaultActiveIndex={0}
            />
          </div>
          <div className="reports-content">
            {reports?.status === 0 && <RevenueExpenseChart />}
            {reports?.status === 1 && (
              <div className="reports-list-view">
                <div className="pricing-filter">
                  <CustomTableStaticFilter
                    header="Pricing Type"
                    column={tableToggleLabel}
                    onClickFilter={handleToggleButton}
                  />
                </div>
                <div className="reports-table">
                  {tablePage === 'base' && <BaseRateList />}
                  {tablePage === 'peak' && <PeakRateList />}
                  {tablePage === 'offpeak' && <OffPeakRateList />}
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

export default DynamicPricing;
